export const categories = [
  {
    key: "film",
    name: "影视新闻",
    description: "最新电影、剧集资讯，独家片场报道与幕后故事。",
  },
  {
    key: "variety",
    name: "综艺资讯",
    description: "热播综艺预告、嘉宾阵容与节目花絮抢先看。",
  },
  {
    key: "gossip",
    name: "娱乐八卦",
    description: "明星动态、圈内传闻与热门话题第一现场。",
  },
  {
    key: "music",
    name: "音乐现场",
    description: "演唱会、音乐节、新歌发布与舞台高光时刻。",
  },
  {
    key: "hotspot",
    name: "热点追踪",
    description: "全网娱乐热点持续追踪，热搜背后的完整故事。",
  },
];

export const videoTypes = [
  { key: "all", name: "全部" },
  { key: "drama", name: "影视剧" },
  { key: "variety", name: "综艺" },
  { key: "short", name: "短视频" },
];